import { Constants } from "../constants";
import { NavigationBarManager } from "../navigation-bar-manager";
import { IScreenStatusCommand } from "../screen-status-command";
import { GenericScreenController } from "./generic-screen-controller";
import { RadiobuttonScreenController } from "./radiobutton-screen-controller";

/**
 * Workflow Controller for screen 6 with custom logic
 */
export class Screen6Controller extends RadiobuttonScreenController {

    constructor(index: number, navigationBarManager: NavigationBarManager) {
        super(index, navigationBarManager);
        this.navigationStatus.progressBarGroupIndex = Constants.GROUP_INDEX_2;
    }

    public initEvents(): void {
        let self = this;
        // When the user selects the answer 'No' a modal window is displayed 
        // with a custom message defined by the user
        this.screenDomElement.find(`.FormChoice__Input.FormChoice__Input--Radio`).click(function (e) {
            var selectedOption = $(e.target).val();
            if (selectedOption == "No") {
                // The message is stored in a hidden field. This hidden field is defined in
                // the form so the admin can change its value.
                let message: string = self.screenDomElement.find(`section.FormStep .Form__Element.FormHidden.FormHideInSummarized`).val() as string;
                $("#tobacco-modal div.dialog-text").html(message)
                $("#tobacco-modal").show();
            }
        });

        this.screenDomElement.find(`.FormChoice__Input.FormChoice__Input--Radio`).click(this.onRadioButtonClick.bind(this));
    }

    public calculateNextScreensInFlow(): Array<IScreenStatusCommand> {
        let visibilityChangeRequest: Array<IScreenStatusCommand> = new Array<IScreenStatusCommand>();
        let selectedOption = this.screenDomElement.find(`.FormChoice__Input.FormChoice__Input--Radio:checked`).val();

        switch (selectedOption) {
            case Constants.YES:
                visibilityChangeRequest.push({
                    targetScreenIndex: Constants.SCREEN_9,
                    active: true
                });
                break;

            case Constants.NO:
                visibilityChangeRequest.push({
                    targetScreenIndex: Constants.SCREEN_7,
                    active: true
                });
                break;
        }

        return visibilityChangeRequest;
    }

    public onRadioButtonClick(e) {
        this.enableNextBasedOnAnswer(e.target.value);
    } 

    public loadScreenInitialStatus(): void {
        let selectedOption = this.screenDomElement.find(`.FormChoice__Input.FormChoice__Input--Radio:checked`).val();
        this.enableNextBasedOnAnswer(selectedOption);
    }

    public enableNextBasedOnAnswer(answer: string) {

        if (answer == "Yes") {
            this.enableNextButton(Constants.NEXT_TITLE);
        } else if (answer == "No") {
            this.enableNextButton(Constants.CHALLENGE_TITLE);
        }
    }
}